import {
  CREATE_REQUEST_MATERIAL,
  LOAD_REQUEST_MATEL,
  EXPORT_REQUEST_MATEL,
  REQUEST_MATERIAL_LOAD_DIVISION,
  REQUEST_MATERIAL_LOAD_DEPARTMENT,
  REQUEST_MATERIAL_LOAD_SECTION,
  REQUEST_MATERIAL_LOAD_PLANT,
  REQUEST_MATERIAL_LOAD_MATERIAL,
  REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT,
  REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT,
  REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT,
  REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT,
  REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT,
  REQUEST_REALTIME_STOCK_MULTIPLE_PLANT,
  REMOVE_LISTS,
} from './actions'

const intialState = {
  lists: [],
  total: 1,
  loading: false,
  check: true,
  check_create: false,
  autoComplete: [],

  // *loadข้อมูลสำหรับ filter
  division_list: [],
  check_division_list: false,

  department_list: [],
  check_department_list: false,

  section_list: [],
  check_section_list: false,

  plant_list: [],
  check_plant_list: false,

  material_list: [],
  check_material_list: false,

  // *preview request material multiple plant
  preview_request_multiple_plant: [],
  check_preview_request_multiple_plant: false,

  // *preview ticket multiple plant
  preview_ticket_multiple_plant: [],
  check_preview_ticket_multiple_plant: false,

  // *create ticket multiple plant
  create_ticket_multiple_plant: [],
  check_create_ticket_multiple_plant: false,

  // *today action
  today_action_multiple_plant: [],
  check_today_action_multiple_plant: false,


  // *preview plant request multiple plant
  preview_plant_request_multiple_plant: [],
  check_preview_plant_request_multiple_plant: false,

  // *request realtime stock multiple plant
  request_realtime_stock_multiple_plant: [],
  check_request_realtime_stock_multiple_plant: false,
}

export default (state = intialState, action) => {
  switch (action.type) {
    case REMOVE_LISTS:
      return intialState

    case LOAD_REQUEST_MATEL.REQUEST:
      const { loading } = action.payload.data
      return {
        ...state,
        loading: loading,
      }

    case LOAD_REQUEST_MATEL.SUCCESS:
      const { page, pageSize } = action.payload
      // an empty result used to come back as a bare [] (no data / total)
      const lists = action.payload.lists || {}
      const rows = Array.isArray(lists.data) ? lists.data : []

      for (let i = 0; i < rows.length; i++) {
        rows[i].rowNumber = i + 1
        if (page > 1) rows[i].rowNumber = rows[i].rowNumber + (page - 1) * pageSize
      }

      return {
        ...state,
        lists: rows,
        total:
          lists.total - 1 <= 0 ? 1 : lists.total <= 0 ? 1 : lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_REQUEST_MATEL.FAILURE:
      return {
        ...state,
        loading: false,
      }

    case CREATE_REQUEST_MATERIAL.REQUEST:
      return {
        ...state,
        check_create: true,
      }

    case CREATE_REQUEST_MATERIAL.SUCCESS:
      return {
        ...state,
        loading: false,
        check_create: false,
      }

    case EXPORT_REQUEST_MATEL.REQUEST:
      return {
        ...state,
        loading: true,
      }

    case EXPORT_REQUEST_MATEL.SUCCESS:
    case EXPORT_REQUEST_MATEL.FAILURE:
      return {
        ...state,
        loading: false,
      }

    // *load division
    case REQUEST_MATERIAL_LOAD_DIVISION.REQUEST:
      return {
        ...state,
        division_list: [],
        check_division_list: true,
      }
    case REQUEST_MATERIAL_LOAD_DIVISION.SUCCESS:
      return {
        ...state,
        division_list: action.payload.lists,
        check_division_list: false,
      }

    // *load department
    case REQUEST_MATERIAL_LOAD_DEPARTMENT.REQUEST:
      return {
        ...state,
        department_list: [],
        check_department_list: true,
      }

    case REQUEST_MATERIAL_LOAD_DEPARTMENT.SUCCESS:
      return {
        ...state,
        department_list: action.payload.lists,
        check_department_list: false,
      }

    // *load section
    case REQUEST_MATERIAL_LOAD_SECTION.REQUEST:
      return {
        ...state,
        section_list: [],
        check_section_list: true,
      }

    case REQUEST_MATERIAL_LOAD_SECTION.SUCCESS:
      return {
        ...state,
        section_list: action.payload.lists,
        check_section_list: false,
      }

    // *load plant
    case REQUEST_MATERIAL_LOAD_PLANT.REQUEST:
      return {
        ...state,
        plant_list: [],
        check_plant_list: true,
      }

    case REQUEST_MATERIAL_LOAD_PLANT.SUCCESS:
      return {
        ...state,
        plant_list: action.payload.lists,
        check_plant_list: false,
      }

    // *load material
    case REQUEST_MATERIAL_LOAD_MATERIAL.REQUEST:
      return {
        ...state,
        material_list: [],
        check_material_list: true,
      }

    case REQUEST_MATERIAL_LOAD_MATERIAL.SUCCESS:
      return {
        ...state,
        material_list: action.payload.lists,
        check_material_list: false,
      }

    // *preview request material multiple plant
    case REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        preview_request_multiple_plant: [],
        check_preview_request_multiple_plant: true,
      }

    case REQUEST_MATERIAL_PREVIEW_REQUEST_MULTIPLE_PLANT.SUCCESS:
      return {
        ...state,
        preview_request_multiple_plant: action.payload.lists,
        check_preview_request_multiple_plant: false,
      }

    // *preview ticket multiple plant
    case REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        preview_ticket_multiple_plant: [],
        check_preview_ticket_multiple_plant: true,
      }

    case REQUEST_MATERIAL_PREVIEW_TICKET_MULTIPLE_PLANT.SUCCESS:
      return {
        ...state,
        preview_ticket_multiple_plant: action.payload.lists,
        check_preview_ticket_multiple_plant: false,
      }

    // *create ticket multiple plant
    case REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        create_ticket_multiple_plant: [],
        check_create_ticket_multiple_plant: true,
      }

    case REQUEST_MATERIAL_CREATE_TICKET_MULTIPLE_PLANT.SUCCESS:
      return {
        ...state,
        create_ticket_multiple_plant: action.payload.lists,
        check_create_ticket_multiple_plant: false,
      }

    // *today action
    case REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        today_action_multiple_plant: [],
        check_today_action_multiple_plant: true,
      }

    case REQUEST_MATERIAL_TODAY_ACTION_MULTIPLE_PLANT.SUCCESS:
      return {
        ...state,
        today_action_multiple_plant: action.payload.lists,
        check_today_action_multiple_plant: false,
      }
    
    // *preview plant request multiple plant
    case REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        preview_plant_request_multiple_plant: [],
        check_preview_plant_request_multiple_plant: true,
      }
    
    case REQUEST_MATERIAL_PREVIEW_PLANT_REQUEST_MULTIPLE_PLANT.SUCCESS:
      return {
        ...state,
        preview_plant_request_multiple_plant: action.payload.lists,
        check_preview_plant_request_multiple_plant: false,
      }

    // *request realtime stock multiple plant
    case REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.REQUEST:
      return {
        ...state,
        request_realtime_stock_multiple_plant: [],
        check_request_realtime_stock_multiple_plant: true,
      }

    case REQUEST_REALTIME_STOCK_MULTIPLE_PLANT.SUCCESS:
        return {
          ...state,
          request_realtime_stock_multiple_plant: action.payload.lists,
          check_request_realtime_stock_multiple_plant: false,
        }

    default:
      return state
  }
}
